var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.281 37.2124H72V69.1081C72 70.7052 70.7052 71.9999 69.1081 71.9999H19.1728C17.5757 71.9999 16.281 70.7052 16.281 69.1081L16.281 37.2124Z",
    fill: "#4081EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 32.0643C16.2803 30.9996 17.1434 30.1365 18.2081 30.1365L70.0713 30.1365C71.1361 30.1365 71.9992 30.9996 71.9992 32.0643V37.2119H16.2803V32.0643Z",
    fill: "#4081EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8071 32.0643C14.8071 30.9996 15.6703 30.1365 16.735 30.1365L68.5982 30.1365C69.6629 30.1365 70.5261 30.9996 70.5261 32.0643V37.2119H14.8071V32.0643Z",
    fill: "#4290F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4371 37.22L70.5275 37.22L67.7115 68.9562C67.5703 70.547 66.1612 71.8367 64.5641 71.8367H14.2574C12.6602 71.8367 11.48 70.547 11.6211 68.9562L14.4371 37.22Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4371 37.22L70.5275 37.22L67.7115 68.9562C67.5703 70.547 66.1612 71.8367 64.5641 71.8367H14.2574C12.6602 71.8367 11.48 70.547 11.6211 68.9562L14.4371 37.22Z",
    fill: "#0F67FF",
    fillOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 19.7338 42.6599)",
    fill: "#0F67FF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 18.5321 54.7781)",
    fill: "#F9F9F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940664 0.996031 31.903 42.6687)",
    fill: "#F9F9F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 30.6985 54.7688)",
    fill: "#F9F9F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 44.0686 42.6599)",
    fill: "#F9F9F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 42.8673 54.7781)",
    fill: "#F9F9F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.86137,
    height: 7.81491,
    rx: 1.92787,
    transform: "matrix(1 0 -0.0940663 0.996031 56.2384 42.6599)",
    fill: "#F9F9F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 53.5364,
    height: 37.7904,
    rx: 6.2984,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 53.5364,
    height: 37.7904,
    rx: 6.2984,
    fill: "#0F67FF",
    fillOpacity: 0.06
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.29834,
    y: 8.29834,
    width: 40.9396,
    height: 6.2984,
    rx: 3.1492,
    fill: "#CCF0F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.29834,
    y: 17.7458,
    width: 40.9396,
    height: 6.2984,
    rx: 3.1492,
    fill: "#CCF0F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.29834,
    y: 27.1936,
    width: 40.9396,
    height: 6.2984,
    rx: 3.1492,
    fill: "#FCEBB8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextReminder);
export default __webpack_public_path__ + "static/media/text-reminder.021c6e89b8df1b22b97a0470f1773c4d.svg";
export { ForwardRef as ReactComponent };